var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#E91E63",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0833 22.8833L22.9083 24.0583L20.2167 21.4166L19.3333 23.4749L17.6667 17.6666L23.5 19.3333L21.3917 20.1916L24.0833 22.8833ZM21.8333 12.6666H10.1667V21.8333H17.175L17.6417 23.4999H10.1667C9.72464 23.4999 9.30072 23.3243 8.98816 23.0118C8.67559 22.6992 8.5 22.2753 8.5 21.8333V10.1666C8.5 9.72456 8.67559 9.30063 8.98816 8.98807C9.30072 8.67551 9.72464 8.49992 10.1667 8.49992H11V6.83325H12.6667V8.49992H19.3333V6.83325H21V8.49992H21.8333C22.75 8.49992 23.5 9.24992 23.5 10.1666V17.6249L21.8333 17.1249V12.6666ZM16 14.3333V18.4999H11.8333V14.3333H16Z",
    fill: "#E91E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocio);
export default __webpack_public_path__ + "static/media/socio.bf20244cdaee2cba4a824596f222228a.svg";
export { ForwardRef as ReactComponent };